const CONNECTION_STATES = {
  active: "ACTIVE",
  suspended: "SUSPENDED",
};

const CONNECTION_TYPES = {
  calendly: "CALENDLY_CONNECTION",
};

export { CONNECTION_TYPES };

export default CONNECTION_STATES;
